module.exports = __webpack_public_path__ + "img/nrcs-logo.713f872c.jpg";